module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Italic-cd7bd7585eb6f0eda3a38fffb2113c59.woff";